import React, { StatelessComponent } from 'react';

import { NewsStub } from '@components/news-widget';
import Rect from '@components/rect';

interface Props {
    compact?: boolean;
}

const NewsListStub: StatelessComponent<Props> = ({ compact }) => {
    return (
        <div className="block centering">
            <Rect width={150} height={48} type="black" />
            <NewsStub
                itemsCount={5}
                type="vertical"
                compact={compact}
            />
            <Rect height={48} />
        </div>
    );
};

export default NewsListStub;
